import React from "react";
import { IImageSettingsControlProps, ImageSettingsControl } from "../image-control/image-settings-control";

interface IImageContrastProps extends IImageSettingsControlProps{}

export const ImageContrastControl = React.memo((props: IImageContrastProps) => {
  return <ImageSettingsControl {...props} label={"Kontrast"} />;
});
